import { createCustomSlice } from 'core/utils';

const initialState = {
    errors: '',
    list: [],
    loading: false,
    selected: {}
};

const coverageSlice = createCustomSlice({
    initialState,
    name: 'coverage',
    reducers: {},
    saga: [
        'coverageDelete',
        'coverageRegistration',
        'getCoverage',
        'getCoverageListing'
    ]
});

export const coverageActions = coverageSlice.actions;

export default coverageSlice.reducer;
